import { API_URL } from "@/shared/config/api";
import { SIDEBAR_API } from "@/constants/api.sidebar";
import type { SidebarNavItem } from "@/shared/sidebar/types";

/** Fire-and-forget sidebar click analytics (web). */
export function trackSidebarItemClick(
  token: string | null | undefined,
  item: Pick<SidebarNavItem, "id" | "type" | "pageKey" | "labelKey"> & {
    label?: string;
  },
  buildingPk?: number | null,
): void {
  if (!token) return;
  const body = {
    itemId: item.id ?? null,
    itemType: item.type || "",
    pageKey: item.pageKey || "",
    label: item.label || item.labelKey || "",
    source: "web",
    buildingId: buildingPk ?? null,
  };
  void fetch(`${API_URL}${SIDEBAR_API.CLICK}`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).catch(() => undefined);
}
